/**
 * Formatação de exibição em pt-BR. Só formata: nenhum cálculo de PCP acontece aqui.
 * Números: `1.234,5`; kg sem casas; espessura com 3 casas; largura em mm inteiros.
 */
const LOCALE = 'pt-BR';

const nf = (min: number, max: number) =>
  new Intl.NumberFormat(LOCALE, { minimumFractionDigits: min, maximumFractionDigits: max });

const int = nf(0, 0);
const one = nf(1, 1);
const three = nf(3, 3);

export const formatKg = (value: number) => int.format(value);
export const formatInt = (value: number) => int.format(value);
export const formatDecimal1 = (value: number) => one.format(value);
/** Espessura em mm com 3 casas (`0,250`) */
export const formatThickness = (value: number) => three.format(value);
/** Largura em mm inteiros */
export const formatWidth = (value: number) => int.format(Math.round(value));
export const formatPercent = (value: number, digits = 0) => `${nf(digits, digits).format(value)}%`;
export const formatHours = (value: number) => `${one.format(value)} h`;
export const formatMinutes = (minutes: number) => `${int.format(Math.round(minutes))} min`;

/** `2026-10-12` → `12/10/2026` (sem passar por `Date`, para não sofrer com fuso). */
export function formatDate(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : iso;
}

/** `2026-10-12T14:05:00-03:00` → `12/10 14:05` (o offset da API já é o de São Paulo). */
export function formatDateTime(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(iso);
  return m ? `${m[3]}/${m[2]} ${m[4]}:${m[5]}` : iso;
}

/** `2026-10-12T14:05:00-03:00` → `14:05` */
export function formatTime(iso: string): string {
  const m = /T(\d{2}):(\d{2})/.exec(iso);
  return m ? `${m[1]}:${m[2]}` : iso;
}

const WEEKDAYS = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];
/** `2026-10-12` → `seg 12/10` */
export function formatWeekdayDate(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return iso;
  const dow = new Date(Date.UTC(+m[1]!, +m[2]! - 1, +m[3]!)).getUTCDay();
  return `${WEEKDAYS[dow]} ${m[3]}/${m[2]}`;
}
